import React from 'react';
import '../styles/DiceFace.css';

interface DiceFaceProps {
  value: number;
  size?: 'small' | 'medium';
}

const DiceFace: React.FC<DiceFaceProps> = ({ value, size = 'small' }) => {
  const sizeClass = size === 'medium' ? 'dice-face-medium' : 'dice-face-small';

  // Dot patterns for each dice value
  const dotPatterns: Record<number, Array<'tl' | 'tr' | 'ml' | 'mc' | 'mr' | 'bl' | 'bc' | 'br'>> = {
    1: ['mc'],
    2: ['tl', 'br'],
    3: ['tl', 'mc', 'br'],
    4: ['tl', 'tr', 'bl', 'br'],
    5: ['tl', 'tr', 'mc', 'bl', 'br'],
    6: ['tl', 'tr', 'ml', 'mr', 'bl', 'br'],
  };

  const dots = dotPatterns[value] || [];
  const isRedDie = value === 1 || value === 4;

  return (
    <div className={`dice-face-display ${sizeClass}`}>
      <div className="dice-grid">
        {dots.map((pos, i) => (
          <span
            key={i}
            className={`dice-dot ${pos} ${isRedDie ? 'red' : ''}`}
          />
        ))}
      </div>
    </div>
  );
};

export default DiceFace;